/* istanbul ignore file */
import GenericController from './generic.controller';

export default class HomeController extends GenericController {
    getHomeInformations = () => {
        return new Promise((resolve, reject) => {
            this.requestGetBack('home/get-informations').then(data => {
                resolve(data)
            }).catch(err => {
                console.log(err);
                reject(err)
            })
        })
    }
}
